import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl
} from "react-bootstrap";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Card from "../../components/Card/Card.jsx";
import { Redirect, withRouter } from "react-router-dom";
import Button from "../../components/CustomButton/CustomButton.jsx";
import * as actions from "../../actions/authActions";


class LoginPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cardHidden: true,
      redirectToReferrer: false,
      authError: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.login = this.login.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
  }
  componentDidMount() {
    setTimeout(
      function() {
        this.setState({ cardHidden: false });
      }.bind(this),
      700
    );

    if(window.location.href.includes('logout'))
      localStorage.removeItem('isAuthenticated');
  }

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value
    });
  }

  onKeyPress(e){
    if(e.key === 'Enter')
      e.preventDefault();
  }

  login(e) {
    e.preventDefault();
    this.props.actions.authenticate(this.state.password, window.location.origin)
    .then((result, err) => {

    if (result){
      this.setState({
        redirectToReferrer: true
      });
      // this.props.history.push('dashboard');
      this.forceUpdate();
    }
    else if(err){
      this.setState({
        authError: (
          <small className="text-danger" style={{marginLeft: 200 + "px"}}>
            Incorrect login! Please try again!
          </small>
        )
      })
    }

    })
    .catch( () =>{
      this.setState({
        authError: (
          <small className="text-danger" style={{marginLeft: 20 + "px"}}>
            Incorrect login! Please try again!
          </small>
        )
      })
    })
  }

  render() {
    const { from } = this.props.location.state || { from: { pathname: "/" } };
    const { redirectToReferrer } = this.state;

    if (redirectToReferrer === true) {
      return <Redirect to='dashboard' />;
      // return <Redirect to={from} />;
    }

    return (
      <Grid>
        <Row style={{ marginTop: 10 + "%", marginBottom: 10 + "%" }}>
          <Col md={4} sm={6} mdOffset={4} smOffset={3}>
            <form>
              <Card
                hidden={this.state.cardHidden}
                textCenter
                title="Login"
                content={
                  <div>
                    {/* <FormGroup>
                      <ControlLabel>Email address</ControlLabel>
                      <FormControl placeholder="Enter email" type="email" />
                    </FormGroup> */}
                    <FormGroup>
                      <ControlLabel>Password</ControlLabel>
                      <FormControl
                        placeholder="Password"
                        type="password"
                        name="password"
                        onChange={this.handleChange}
                        onKeyDown={this.onKeyPress}
                      />
                    </FormGroup>
                    {this.state.authError}
                  </div>
                }
                legend={<Button onClick={this.login} bsStyle="info">Login</Button>}
                ftTextCenter
              />
              {/* <Button onClick={this.login} bsStyle="info">
                Login
              </Button> */}
            </form>
          </Col>
        </Row>
      </Grid>
    );
  }
}


function mapStateToProps(state) {

  return {

  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginPage));
